import React, {Dispatch, SetStateAction} from "react"
import {IOrder} from "../../../../../models/order"
import leftFillNum from "../../../../../utils/leftFillNum"
import StatusLabel from "../../../../generic/dataDisplay/StatusLabel"
import Button from "../../../../generic/buttons/Button"
import {useNavigate} from "react-router-dom"
import {useAppDispatch} from "../../../../../hooks/redux"
import classes from "./DriverOrderLine.module.scss"
import {
  driverAcceptOrder,
  driverFinishOrder,
  fetchDriverOrdersCurrent,
  fetchDriverOrdersNew
} from "../../../../../store/actions/orderActions"

interface IDriverOrderLineProps {
  order: IOrder
  acceptOrderSuccess: Dispatch<SetStateAction<boolean>>
  finishOrderSuccess: Dispatch<SetStateAction<boolean>>
}

function DriverOrderLine({order, acceptOrderSuccess, finishOrderSuccess}: IDriverOrderLineProps) {

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const arAddressFrom = []

  if (order.address_from)
    arAddressFrom.push(order.address_from)

  if (order.flat_from)
    arAddressFrom.push(`кв. ${order.flat_from}`)

  const arAddressTo = []

  if (order.address_to)
    arAddressTo.push(order.address_to)

  if (order.flat_to)
    arAddressTo.push(`кв. ${order.flat_to}`)

  const orderAcceptHandler =  async (id: number) => {
    const acceptedID = await dispatch(driverAcceptOrder(id))
    if (acceptedID) {
      acceptOrderSuccess(true)
      dispatch(fetchDriverOrdersNew({page: 1, pageSize: 0}))
    }
  }

  const orderFinishHandler = async (id: number) => {
    const finishedID = await dispatch(driverFinishOrder(id))
    if (finishedID) {
      finishOrderSuccess(true)
      dispatch(fetchDriverOrdersCurrent({page: 1, pageSize: 0}))
    }
  }

  return (
    <div className={classes.wrap}>
      <div className={classes.order}>
        <div className={classes.number}>№{leftFillNum(order.id)}</div>
        <div className={classes.status}><StatusLabel id={Number(order.status_id)} type={"order"}/></div>
      </div>
      <div className={classes.data}>
        <div className={classes.details}>
          <div className={classes.client_fio}>{order.client_fio}</div>
          <div className={classes.props}>
            <div className={classes.props_item}>
              <div className={classes.props_label}>Время подачи:</div>
              <div className={[classes.props_value, classes.props_value_time].join(" ")}>{order.request_time}</div>
            </div>
            <div className={classes.props_item}>
              <div className={classes.props_label}>Стоимость:</div>
              <div className={[classes.props_value, classes.props_value_price].join(" ")}>{order.price ? `${order.price} руб.` : `-`}</div>
            </div>
            <div className={classes.props_item}>
              <div className={classes.props_label}>Вес:</div>
              <div className={[classes.props_value, classes.props_value_weight].join(" ")}>{order.client_weight}</div>
            </div>
          </div>
        </div>
        <div className={classes.waypoint}>
          <div className={classes.waypoint_item}>
            <div className={[classes.waypoint_drawing, classes.waypoint_drawing_from].join(" ")}>
              <span></span>
            </div>
            <div className={classes.waypoint_data}>
              <div className={classes.waypoint_address}>{arAddressFrom.length ? arAddressFrom.join(", ") : "-"}</div>
              <div className={classes.waypoint_city}>{order.city_from || "-"}</div>
            </div>
          </div>
          <div className={classes.waypoint_item}>
            <div className={[classes.waypoint_drawing, classes.waypoint_drawing_to].join(" ")}>
              <span></span>
            </div>
            <div className={classes.waypoint_data}>
              <div className={classes.waypoint_address}>{arAddressTo.length ? arAddressTo.join(", ") : "-"}</div>
              <div className={classes.waypoint_city}>{order.city_to || "-"}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.controls}>
        {order.status_id === 2 &&
          <Button
            className={classes.button_accept}
            size={"sm"}
            onClick={() => orderAcceptHandler(order.id)}
          >Подтвердить заявку</Button>
        }
        {order.status_id === 4 &&
          <Button
            className={classes.button_finish}
            size={"sm"}
            onClick={() => orderFinishHandler(order.id)}
          >Завершить</Button>
        }
      </div>
      <div
        className={classes.clickable}
        onClick={() => navigate(`/order/${order.id}`)}
      ></div>
    </div>
  )
}

export default DriverOrderLine